import { useState, useEffect } from "react";
import { SECONDS_IN_DAY, SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from "../data/constants/workflowDefConstants";

export const useWorkflowDuration = (onModifiedChange) => {

    const [duration, setDuration] = useState(0);
    const [workflowDays, setWorkflowDays] = useState(0);
    const [workflowHours, setWorkflowHours] = useState(0);
    const [workflowMinutes, setWorkflowMinutes] = useState(0);
    const [workflowSeconds, setWorkflowSeconds] = useState(0);

    useEffect(() => {

        setDuration(
            workflowDays + workflowHours + workflowMinutes + workflowSeconds
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workflowDays, workflowHours, workflowMinutes, workflowSeconds]);

    const createTimeUnitHandler = (multiplier) => (value) => {
        let seconds = 0;
        if (value && !Number.isNaN(value)) {
            seconds = Math.floor(value * multiplier);
        }
        return seconds;
    };

    const createHandleChange = (setter, multiplier = 1) => (value) => {
        const seconds = createTimeUnitHandler(multiplier)(value)
        setter(seconds);
        if (onModifiedChange) onModifiedChange(true)
    }

    const handleDaysChange = createHandleChange(setWorkflowDays, SECONDS_IN_DAY)
    const handleHoursChange = createHandleChange(setWorkflowHours, SECONDS_IN_HOUR)
    const handleMinutesChange = createHandleChange(setWorkflowMinutes, SECONDS_IN_MINUTE)
    const handleSecondsChange = createHandleChange(setWorkflowSeconds)


    return {
        duration,
        workflowDays,
        workflowHours,
        workflowMinutes,
        workflowSeconds,

        setDuration,
        setWorkflowDays,
        setWorkflowHours,
        setWorkflowMinutes,
        setWorkflowSeconds,

        handleDaysChange,
        handleHoursChange,
        handleMinutesChange,
        handleSecondsChange
    }

}
